module.exports = __webpack_public_path__ + "media/blog.042e0a51.mp4";